// 书籍状态
export const BookStatus = [
  { label: "正常", value: 1, color: "success" },
  { label: "下架", value: 2, color: "error" },
];

// 图片状态
export const ImageStatus = [
  { label: "已完成", value: 1, color: "success" },
  { label: "未完成", value: 2, color: "processing" },
  { label: "解析失败", value: 3, color: "error" },
  { label: "其他错误", value: 4, color: "warning" },
];

// 笔记分类
export const NoteCategory = [
  { label: "精选助记", value: 1, color: "success" },
  { label: "用户笔记", value: 2, color: "processing" },
];

// 用户状态
 export const UserStatus = [
   { label: "正常", value: 1, color: "success" },
   { label: "禁用", value: 2, color: "error" },
   // { label: "已下单", value: 3, color: "processing" },
   { label: "注销", value: 4, color: "warning", disabled: true },
 ];

 // 用户角色
export const UserRole = [
  { label: "管理员", value: 1, color: "processing" },
  { label: "客服", value: 30, color: "error" },
];

// 书籍来源
export const BookSource = [
  { label: "自营", value: 1, color: "processing" },
  { label: "用户", value: 2, color: "default" },
];

// 书籍类型
export const BookType = [
  { label: "通用书籍", value: 1, color: "processing" },
  { label: "拍书翻译", value: 2, color: "error" },
  { label: "拍物学词", value: 3, color: "success" },
];

// 注册渠道
export const RegisterChannel = [
  { label: "APP注册", value: "captcha" },
  { label: "考研英语词汇速记", value: "考研英语词汇速记" },
  { label: "线性代数辅导讲义", value: "线性代数辅导讲义" },
  { label: "高等数学辅导讲义", value: "高等数学辅导讲义" },
  { label: "四级真题解析", value: "四级真题解析" },
  { label: "六级真题解析", value: "六级真题解析" },
  { label: "听力练习", value: "听力练习" },
  { label: "分享赚钱", value: "分享赚钱" },
];
